<template>
  <section>
    <h2>E-Mail Vorschau</h2>
    <div class="email email-part">
      <h3>Betreff: {{ maildata ? maildata.subject : "[Kein Betreff]" }}</h3>
      <iframe
        ref="emailContent"
        class="content"
        sandbox="allow-same-origin allow-popups"
      ></iframe>
    </div>
    <div v-if="maildata.attachments[0]" class="attachments email-part">
      <div class="attachments-grid">
        <div class="attachments-list">
          <h4>Anhänge</h4>
          <ul>
            <li
              v-for="attachment in maildata.attachments"
              :key="attachment.name"
            >
              <div
                class="attachmentbutton"
                @click="changeAttachment(attachment)"
              >
                <i class="far fa-file-alt"></i>
                <span>{{ attachment.name }}</span>
              </div>
            </li>
          </ul>
        </div>
        <div v-if="activeAttachment" class="attachment-preview">
          <EmailAttachment
            :mime-type="activeAttachment.mimeType"
            :name="activeAttachment.name"
            :email-id="activeAttachment.emailId"
          ></EmailAttachment>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import EmailAttachment from "./EmailAttachment.vue";
import gql from "graphql-tag";

export default {
  components: {
    EmailAttachment
  },
  props: ["emailId"],
  data() {
    return {
      activeAttachment: null,
      maildata: { attachments: [] }
    };
  },
  watch: {
    maildata: {
      deep: true,
      handler() {
        let iframe = this.$refs.emailContent;
        if (iframe) {
          //The component has been created
          let contentDocument =
            iframe.contentDocument || iframe.contentWindow.document;

          if (this.maildata) {
            contentDocument.body.innerHTML = this.maildata.content;
          } else {
            contentDocument.body.innerHTML = "kein Nachricht Inhalt";
          }
          for (let link of contentDocument.body.getElementsByTagName("a")) {
            link.target = "_blank";
          }
        }
      }
    }
  },
  methods: {
    changeAttachment(attachment) {
      this.activeAttachment = null;
      setTimeout(() => {
        this.activeAttachment = attachment;
      }, 150);
    }
  },
  apollo: {
    maildata: {
      query: gql`
        query GetMailRegistrationById($id: Int!) {
          getMailRegistrationById(id: $id) {
            id
            content
            attachments {
              mimeType
              name
              emailId
            }
            subject
          }
        }
      `,
      variables() {
        return {
          id: this.emailId
        };
      },
      update: data => {
        return data.getMailRegistrationById;
      }
    }
  }
};
</script>
